import * as React from 'react';
import {
  HeaderCellWrapper,
  HeaderCell,
  HeaderIcon,
  IconSortDesc,
  IconSortAsc,
} from 'components/Table';
import { SortDirection, ColumnType } from 'utils/shared/trades/types';
import type { FlowMetricMode } from 'utils/shared/trades/presets';
import { ChainSortState } from './OptionChainTable';
import { ChainDashboardRow } from './styles';

interface Props {
  headers: { name: string; sortKey: string; columnType: ColumnType }[];
  columns: string;
  chainSortState: ChainSortState;
  metricMode?: FlowMetricMode;
}

const ChainTableHeader: React.FC<Props> = ({
  headers,
  columns,
  chainSortState,
  metricMode = 'total',
}) => {
  const displayHeaders = React.useMemo(
    () =>
      headers.map((header) => {
        if (metricMode !== 'net') {
          return header;
        }

        if (header.sortKey === 'totalSize') {
          return { ...header, name: 'Net Size', sortKey: 'netSize' };
        }

        if (header.sortKey === 'totalPremium') {
          return { ...header, name: 'Net Premium', sortKey: 'netPremium' };
        }

        return header;
      }),
    [headers, metricMode],
  );
  return (
    <ChainDashboardRow removePad $columns={columns}>
      {displayHeaders.map((t, i) => {
        if (t.sortKey === 'expand') {
          return (
            <HeaderCellWrapper key="expand" removePad>
              <HeaderCell>
                <span className="cell-name" />
              </HeaderCell>
            </HeaderCellWrapper>
          );
        }
        const isActiveSort =
          t.sortKey === chainSortState.sortKey &&
          chainSortState.sortDirection !== SortDirection.None;
        return (
          <HeaderCellWrapper
            key={t.name}
            removePad={i + 1 === headers.length}
            isActiveSort={isActiveSort}
            onClick={() => chainSortState.handleSort(t.sortKey)}
          >
            <HeaderCell>
              <span className="cell-name">{t.name}</span>
              {isActiveSort && chainSortState.sortDirection === SortDirection.Desc && (
                <HeaderIcon>
                  <IconSortDesc />
                </HeaderIcon>
              )}
              {isActiveSort && chainSortState.sortDirection === SortDirection.Asc && (
                <HeaderIcon>
                  <IconSortAsc />
                </HeaderIcon>
              )}
            </HeaderCell>
          </HeaderCellWrapper>
        );
      })}
    </ChainDashboardRow>
  );
};

export default React.memo(ChainTableHeader);
